// import React from "react";
// import moment from "moment";
import axios from 'axios';
import{
	_axiosCall
} from '../../../helpers/apicalls';
import{
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage
} from '../../../helpers/utils';

import buyersListActions from '../../../../redux/actions/buyersListActions';
import { Publisher } from "./../../../pubsub/publisher.js";


export const  _getUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
  
  const ssoOrg = _getSSOOrg();
  console.log(ssoOrg);
  if (ssoOrg === "MPSSO") {
	  return _getMPUserSSO(ssoToken, props, setUserProfile);
  } else if (ssoOrg === "REALPLUS") {
	  return _getRealPlusUserSSO(ssoToken, props, setUserProfile);
  } else if (ssoOrg === "ELLIMAN") {
	  return _getEllimanUserSSO(ssoToken, props, setUserProfile);
  }
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.REALOGY_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  const allowedEmails = ["previewrlgy@gmail.com", "bonita.lau@cbhome.com"];
  
  return _axiosCall(userData)
	.then(res => {
	console.log("_getUserData res back ,", res);
	if(res){
	  let oktaUser = Object.assign({}, res);
	  oktaUser['authType'] = 'sso';
	  oktaUser['role'] = ['complete-199'];
	  oktaUser['subscriptionPlan'] = 'custom-sso';
	  oktaUser['id']= res.sub;
	  oktaUser['firstName'] = res.given_name;
	  oktaUser['lastName'] = res.family_name;
	  oktaUser['title'] = "Real Estate Professional";
	  oktaUser['company'] = "Coldwell Banker Warburg";
	  oktaUser['subscriptionId'] = 'custom-sso';
	  oktaUser['ssoOrganiztion'] = 'cbwarburg';
	//console.log(oktaUser) 
	  //if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
			  _getUser(oktaUser).then(user => {
				  if(user){
					  
					  const combinedUser = Object.assign({}, oktaUser, user);
					  dispatch(setUserProfile(combinedUser));
					  dispatch(buyersListActions.setUserData(combinedUser));
					  Publisher.publish("login", combinedUser);
				  }else{
					_checkWarburgAuthorization(oktaUser).then(result => {
						
						if(result && result.authentication === true || (oktaUser.email && (oktaUser.email.toLowerCase().indexOf("cbrealty.com")>=0) || allowedEmails.indexOf(oktaUser.email.toLowerCase())>=0)){
							_createUser(oktaUser).then(user => {
								  const combinedUser = Object.assign({}, oktaUser, user);
								  dispatch(setUserProfile(combinedUser));
								  dispatch(buyersListActions.setUserData(combinedUser));
								  Publisher.publish("login", combinedUser);
							})
						}else{
							_deleteSSOToken();
							window.location.href = "/cbwarburg?error=unauthorized";
						}
						
						
					}).catch(error =>{
						console.log(error);
						dispatch(setUserProfile(null));
						_deleteSSOToken();
						window.location.href = "/cbwarburg?error=unauthorized";
					});
					  
				  }
			  }).catch(error =>{
				  console.log(error);
				 dispatch(setUserProfile(null));
				 _deleteSSOToken();
				  window.location.href = "/cbwarburg?error=unauthorized";
			});
	  //   }else{
		// 	window.location.href = "/login";
	  // }
	}else{
			dispatch(setUserProfile(null));
			_deleteSSOToken();
			window.location.href = "/cbwarburg?error=unauthorized";
	}
	

  })
  .catch(error => {
	
	if(error && error.status && error.status == 401){
		console.log("error 401")
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	}
	console.log(error)
	
  });
}

export const  _getMPUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.MP_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  
  
  return _axiosCall(userData)
	.then(res => {
	console.log("_getUserData res back ,", res);
	if(res){
	
	  let oktaUser = Object.assign({}, res);
			  oktaUser['id']= res.sub;
			oktaUser['authType'] = 'sso';
			oktaUser['ssoType'] = 'MPSSO';
			oktaUser['avatar'] = oktaUser['avatar'] ? oktaUser['avatar'] : "https://buyerslist.s3.amazonaws.com/account.png";
			if(res.AllProfile){
				oktaUser = Object.assign({}, oktaUser, res.AllProfile);
			}
			  _getUser(oktaUser).then(user => {
				  console.log(user)
				  if(user){
					  
					  const combinedUser = Object.assign({}, user, oktaUser);
					  dispatch(setUserProfile(combinedUser));
					  dispatch(buyersListActions.setUserData(combinedUser));
					  Publisher.publish("login", combinedUser);
				  }else{
					dispatch(setUserProfile(oktaUser));
					Publisher.publish("login", (oktaUser));
					//_deleteSSOToken();
					  
				  }
			  }).catch(error =>{
				  console.log(error);
				  dispatch(setUserProfile(null));
				  _deleteSSOToken();
			});
	}else{
			dispatch(setUserProfile(null));
			_deleteSSOToken();
	}
	

  })
  .catch(error => {
	
	if(error && error.status && error.status == 401){
		console.log("error 401")
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	}
	console.log(error)
	
  });
}

export const  _getRealPlusUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.REALPLUS_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  
  
  return _axiosCall(userData)
	  .then(res => {
	  console.log("_getUserData res back ,", res);
	  if(res){
		let oktaUser = Object.assign({}, res);
		let nameParts = res.name.split(' ');
		let first_name = nameParts[0]
		let last_name = nameParts[nameParts.length-1]
		oktaUser['authType'] = 'sso';
		oktaUser['role'] = ['complete-199'];
		oktaUser['subscriptionPlan'] = 'custom-sso';
		oktaUser['id']= res.sub;
		oktaUser['firstName'] = first_name;
		oktaUser['lastName'] = last_name;
		oktaUser['title'] = "Real Estate Professional";
		oktaUser['subscriptionId'] = 'custom-sso';
		oktaUser['ssoOrganiztion'] = 'realplus';
	  //console.log(oktaUser) 
		//if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
				_getUser(oktaUser).then(user => {
					if(user){
						
						const combinedUser = Object.assign({}, oktaUser, user);
						dispatch(setUserProfile(combinedUser));
						dispatch(buyersListActions.setUserData(combinedUser));
						Publisher.publish("login", combinedUser);
					}else{
					 
					  _createUser(oktaUser).then(user => {
							const combinedUser = Object.assign({}, oktaUser, user);
							dispatch(setUserProfile(combinedUser));
							dispatch(buyersListActions.setUserData(combinedUser));
							Publisher.publish("login", combinedUser);
					  })
							 
					}
				}).catch(error =>{
					console.log(error);
				   dispatch(setUserProfile(null));
				   _deleteSSOToken();
					window.location.href = "/realplus?error=unauthorized";
			  });
		//   }else{
		  // 	window.location.href = "/login";
		// }
	  }else{
			  dispatch(setUserProfile(null));
			  _deleteSSOToken();
			  window.location.href = "/realplus?error=unauthorized";
	  }
	  
  
	})
	.catch(error => {
	  
	  if(error && error.status && error.status == 401){
		  console.log("error 401")
		  dispatch(setUserProfile(null));
		  _deleteSSOToken();
	  }
	  console.log(error)
	  
	});
}

export const _getEllimanUserSSO = async (ssoToken, props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const claims = ssoToken.claims || {};
  const userId = claims.oid; // Use oid to fetch from Graph

  const headers = {
	Authorization: `Bearer ${ssoToken.access_token}`
  };

  const userData = {
	url: `https://graph.microsoft.com/v1.0/users/${userId}?$select=id,displayName,givenName,surname,jobTitle,department,officeLocation,city,state,postalCode,streetAddress,mail,mobilePhone,businessPhones`,
	method: "get",
	headers
  };

  logToLocalStorage("sso_request_graph_user_by_oid", { data: userData });

  return _axiosCall(userData)
	.then(res => {
	  if (res) {
		// Enforce NY-only access (case-insensitive and flexible)
		const allowedStates = ["ny", "new york"];
		const stateRaw = res.state || "";
		const stateNormalized = stateRaw.trim().toLowerCase();

		const isNYUser = allowedStates.includes(stateNormalized);
		

		let oktaUser = {
		  ...res,
		  id: claims.sub, // Internal key
		  authType: 'sso',
		  ssoType: 'ELLIMAN',
		  title: "Real Estate Professional",
		  company: "Douglas Elliman",
		  subscriptionPlan: 'custom-sso',
		  subscriptionId: 'custom-sso',
		  role: ['complete', 'broker-outreach'],
		  firstName: res.givenName,
		  lastName: res.surname,
		  ssoOrganiztion: "elliman",
		  ssoOID: userId,
		  email: res.mail || res.userPrincipalName,

		  // Contact & location
		  mobilePhone: res.mobilePhone || null,
		  primaryPhone: res.businessPhones && res.businessPhones.length > 0 ? res.businessPhones[0] : null,
		  office: res.officeLocation || null,
		  streetAddress: res.streetAddress || null,
		  city: res.city || null,
		  state: res.state || null,
		  zipCode: res.postalCode || null
		};

		logToLocalStorage("sso_graph_user_response", { res, user: oktaUser });
		
		if (!isNYUser) {
		  logToLocalStorage("sso_user_blocked_non_ny", {
			state: res.state,
			normalized: stateNormalized,
			userId: claims.sub,
			user: oktaUser
		  });
		  Publisher.publish("track-mp.userLogin.ssoNoneEllimanNY", { user: oktaUser, customData: oktaUser });
		  dispatch(setUserProfile(null));
		  _deleteSSOToken();
		  window.location.href = "/elliman?error=unauthorized";
		  return;
		}

		return _getUser(oktaUser).then(user => {
		  const combinedUser = user ? { ...oktaUser, ...user } : oktaUser;

		  if (!user) {
			return _createUser(oktaUser).then(created => {
			  const finalUser = { ...oktaUser, ...created };
			  dispatch(setUserProfile(finalUser));
			  dispatch(buyersListActions.setUserData(finalUser));
			  Publisher.publish("login", finalUser);
			  Publisher.publish("track-mp.userCreate", finalUser);
			});
		  }

		  dispatch(setUserProfile(combinedUser));
		  dispatch(buyersListActions.setUserData(combinedUser));
		  Publisher.publish("login", combinedUser);
		  Publisher.publish("track-mp.userLogin.ssoMSGraphProfile", { user: combinedUser, customData: combinedUser });
		});
	  } else {
		dispatch(setUserProfile(null));
		_deleteSSOToken();
		window.location.href = "/elliman?error=unauthorized";
	  }
	})
	.catch(error => {
	  if (error && error.status === 401) {
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	  }
	  console.log("Elliman user fetch error:", error);
	});
};




export const _getUser = async (user) => {
		
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/userdata/${user.id}`,
			method: "get"
		};
		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				if(res && res.length>0){
					return res[0];
				}else{
					return false;
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});
		return formattedData;
};

export const _createUser = async (user) => {
		
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/createssouser/${user.id}`,
			method: "post",
			query: user
		};

		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				console.log('Data', res);
				if(res && res.length>0){
					return res[0];
				}else{
					return false;
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});

		// console.log(formattedData)
		return formattedData;
};


export const  _doUserSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoOrg = _getSSOOrg();
 
  if (ssoOrg === "MPSSO") {
	  return _doUserMPSSOLogout(props, setUserProfile);
  } else if (ssoOrg === "REALPLUS") {
	  return _doUserRealPlusSSOLogout(props, setUserProfile);
  } else if (ssoOrg === "ELLIMAN") {
	  return _doUserEllimanSSOLogout(props, setUserProfile);
  }
	
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.REALOGY_BASE_URL}logout?client_id=${process.env.REALOGY_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALOGY_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const  _doUserRealPlusSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.REALPLUS_BASE_URL}logout?client_id=${process.env.REALPLUS_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALPLUS_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const  _doUserMPSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.MP_BASE_URL}logout?client_id=${process.env.MP_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.MP_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const _doUserEllimanSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();

  const logURL = `https://login.microsoftonline.com/${process.env.ELLIMAN_CLIENT_ID}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(process.env.ELLIMAN_LOGOUT_REDIRECT_URI)}`;

  logToLocalStorage("sso_user_logout", { logURL });
  const { decodedClaims } = ssoToken;
  Publisher.publish("track-mp.userLogin.ssoLogout", {user: {
		  id: decodedClaims.sub,
		  ...decodedClaims
		}});
  _deleteSSOToken();
  dispatch(setUserProfile(null));
  Publisher.publish("logout", {});

  window.location.href = logURL;
  return false;
};


export const _checkWarburgAuthorization = (user) => {
	return new Promise((resolve, reject) => {
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/realogy/cbwarburg`,
			method: "get"
		};
		
		let formattedData = _axiosCall(axiosData)
			.then(res => {
				//console.log(user, res)
				if(user && user.id && res && res.agents && res.agents.filter(agent => agent && agent.companyOfficeAssociation && agent.companyOfficeAssociation.agentOktaIds && agent.companyOfficeAssociation.agentOktaIds.indexOf(user.id)>=0).length>0){
					resolve({authentication:true, agent: user})
					
				}
				resolve({authentication:false, agent: user});
				
			})
			.catch(error => {
				reject(Error(error));
			});
		
		// console.log(formattedData)
		return formattedData;
	  });

};

export const _setSSOToken = (ssoToken, ssoOrg) => {
	ssoOrg = ssoOrg ? ssoOrg : 'CBWarburg';
	deleteLocalStorage("marketproof", "_ssoTokenType");
	setLocalStorage("marketproof", "_ssoTokenType", ssoOrg);
	return setLocalStorage(ssoOrg, '_SSOToken', ssoToken);
}

export const _deleteSSOToken = () => {
	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	deleteLocalStorage(ssoOrg, '_SSOToken');
	return deleteLocalStorage("marketproof", "_ssoTokenType");
}
export const _getSSOToken = () => {

	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	return getLocalStorage(ssoOrg, '_SSOToken')
}

export const _getSSOOrg = () => {
	return getLocalStorage("marketproof", "_ssoTokenType");
}

export const _doSSOLogout = (props, setUserProfile) => {
	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	return _doUserSSOLogout(props, setUserProfile, ssoOrg)
}

export const logToLocalStorage = (eventType, data = {}) => {
  const key = "sso_logs";

  try {
	if (typeof localStorage === "undefined") return;

	let existing = [];

	try {
	  const raw = localStorage.getItem(key);
	  existing = raw ? JSON.parse(raw) : [];
	} catch (parseErr) {
	  existing = [];
	}

	existing.push({
	  event: eventType,
	  timestamp: new Date().toISOString(),
	  data,
	  url: window.location.href
	});

	localStorage.setItem(key, JSON.stringify(existing));
  } catch (storageErr) {
	// Swallow silently — logging failure should not interrupt app flow
  }
};

export const decodeIdToken = (idToken) => {
  try {
	const parts = idToken.split('.');
	if (parts.length !== 3) return null;

	const payload = parts[1];
	const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
	return decoded;
  } catch (e) {
	console.error("Error decoding ID token:", e);
	return null;
  }
};

